<div class="sidenav-header d-flex justify-content-between">
  <i
    (click)="sidenavToggler()"
    class="fas fa-times p-4 cursor-pointer position-absolute end-0 top-0 d-none d-xl-none"
    aria-hidden="true"
    id="iconSidenav"
  ></i>
  <a class="navbar-brand m-0" href="/">
    @if (mijnAssist) {
      <img
        src="../../assets/img/logo-mijnassist.png"
        class="navbar-brand-img h-100"
        alt="main_logo"
      />
      <img src="../../assets/img/icon-assist.png" class="navbar-brand-icon h-100" alt="main_icon" />
    } @else {
      @if (global.isWhiteLabelVsvw) {
        <img src="../../assets/img/logo-vsvw.png" class="navbar-brand-img h-100" alt="main_logo" />
        <img src="../../assets/img/icon-vsvw.png" class="navbar-brand-icon h-100" alt="main_icon" />
      } @else {
        <img
          src="../../assets/img/logo-assist.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <img
          src="../../assets/img/icon-assist.png"
          class="navbar-brand-icon h-100"
          alt="main_icon"
        />
      }
    }
    <!--
    @if(global.organization.FederationId == federations.VlaamsSteunpuntVrijwilligerswerk) {
    }
    @else {
      <img src="../../assets/img/logo-assist.png" class="navbar-brand-img h-100" alt="main_logo" />
      <img src="../../assets/img/icon-assist.png" class="navbar-brand-icon h-100" alt="main_icon" />
    }
    -->
  </a>
  <div class="me-3 mt-1">
    <div
      (click)="sidenavToggler()"
      class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none me-auto"
    >
      <a class="nav-link text-body p-0">
        <div class="sidenav-toggler-inner">
          <i class="sidenav-toggler-line bg-primary"></i>
          <i class="sidenav-toggler-line bg-primary"></i>
          <i class="sidenav-toggler-line bg-primary"></i>
        </div>
      </a>
    </div>
    <div
      class="collapse navbar-collapse me-md-0 me-sm-4 mt-sm-0 mt-2 d-xl-block d-none"
      id="navbar"
    >
      <ul class="navbar-nav justify-content-end ms-auto">
        <li class="nav-item d-xl-none ps-3 pe-0 d-flex align-items-center">
          <a (click)="toggleSidenav()" class="nav-link text-body p-0" id="iconNavbarSidenav">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line bg-primary"></i>
              <i class="sidenav-toggler-line bg-primary"></i>
              <i class="sidenav-toggler-line bg-primary"></i>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="collapse navbar-collapse w-auto h-auto overflow-hidden" id="sidenav-collapse-main">
  <ul class="navbar-nav">
    <li *ngFor="let item of menuItems" class="nav-item">
      <ng-container
        *ngIf="
          ((hasVat && item.isVat) ||
            (!hasVat && item.isVat === false) ||
            item.isVat == undefined ||
            item.isVat == null) &&
          (!item.vatTypeIds ||
            (vatTypeId != null && item.vatTypeIds.indexOf(vatTypeId) > -1)) &&
          (!item.federationIds ||
            (federationid && item.federationIds.indexOf(federationid) > -1)) &&
          (!item.subscriptionTypeIds ||
            (subscriptionTypeId && item.subscriptionTypeIds.indexOf(subscriptionTypeId) > -1))
        "
      >
        <a
          *ngIf="!item.subItems || item.subItems.length == 0"
          class="nav-link"
          (click)="closeOnMobile()"
          [routerLink]="item.route"
          routerLinkActive="active"
        >
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa-solid {{ item.icon }} text-primary text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">{{ item.name }}</span>
        </a>
        <a
          *ngIf="item.subItems && item.subItems.length > 0"
          data-bs-toggle="collapse"
          [attr.aria-expanded]="!item.collapsed"
          [attr.aria-expanded]="item.name"
          role="button"
          (click)="navigateOnToggle(item)"
          class="nav-link"
          role="button"
        >
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa-solid {{ item.icon }} text-primary text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">{{ item.name }}</span>
        </a>
        <div
          *ngIf="item.subItems && item.subItems.length > 0 && item.collapsed != undefined"
          class="collapse"
          #collapse="ngbCollapse"
          [(ngbCollapse)]="item.collapsed"
        >
          <ul class="nav ms-4 mb-2">
            <li class="nav-item" *ngFor="let child of getFilteredSubItems(item)">
              <hr *ngIf="child.separator" class="horizontal dark my-1" style="margin-bottom: 0.4rem" />
              <a
                class="nav-link"
                (click)="closeOnMobile()"
                [routerLink]="child.route"
                [queryParams]="child.queryParams"
                routerLinkActive="active"
              >
                <span class="sidenav-mini-icon"> {{ child.mini }} </span>
                <span class="sidenav-normal" style="white-space: pre-wrap; line-height: 1.3">{{ child.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>
    </li>
    <li class="nav-item" *ngIf="!mijnAssist">
      <hr class="horizontal dark" />
    </li>
    <li class="nav-item d-none">
      <a class="nav-link" [routerLink]="createSettingsUrl()">
        <div
          class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
        >
          <i class="fa-solid fa-cog text-primary text-sm opacity-10"></i>
        </div>
        <span class="nav-link-text ms-1">Voorkeuren en instellingen</span>
      </a>
    </li>
    <li class="nav-item" *ngIf="showOldAssist">
      <a class="nav-link" href="https://app.assistonline.eu/dba/home.aspx" target="_blank">
        <div
          class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
        >
          <img src="../../../../../assets/img/icons/icon_assist_new.png" style="width: 16px" />
        </div>
        <span class="nav-link-text ms-1">Vorige versie van Assist</span>
      </a>
    </li>
    <li class="nav-item" *ngIf="!mijnAssist">
      <a class="nav-link" href="https://help.assistonline.eu" target="_blank">
        <div
          class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
        >
          <i class="fa-solid fa-circle-question text-primary text-sm opacity-10"></i>
        </div>
        <span class="nav-link-text ms-1">Online help</span>
      </a>
    </li>
  </ul>
</div>

<div
  *ngIf="global.organization"
  class="sidenav-footer bg-white mx-3 my-3"
  style="position: fixed; bottom: 0px; width: 242px"
>
  <a
    *ngIf="!mijnAssist && global.organization.FederationId == 1030 && subscriptionTypeId == 5"
    href="https://www.vlaanderenvrijwilligt.be/"
    target="_blank"
  >
    <img src="../../../../../assets/img/logo-vsvw.png" class="logo-partner w-100 px-3 my-4" />
  </a>
  <div *ngIf="mijnAssist" class="mx-auto mb-3 text-center align-items-center">
    <div class="d-none d-xl-block">
      @if (global.startSettings.PublicAccessLogo) {
        <a [href]="global.organization.Address.Website" target="_blank">
          <img
            [src]="global.imageUrl + global.startSettings.PublicAccessLogo"
            class="logo-org mb-2"
          />
        </a>
      }
    </div>
    <p class="mb-0 font-weight-bold" style="color: #344767">
      {{ global.organization.Name }}
    </p>
    <!-- 
    <p class="mb-0" style="font-size: 0.75rem">
      {{ global.organization.Address.Street }}&nbsp;{{ global.organization.Address.Nr }}
    </p>
    <p class="mb-0" style="font-size: 0.75rem">
      {{ global.organization.Address.PostCode }}&nbsp;{{ global.organization.Address.Location }}
    </p>
    <p class="mb-0" style="font-size: 0.75rem">Ond.nr.: {{ global.organization.BTWNumber }}</p>
    <p class="mb-0" style="font-size: 0.75rem">
      RPR:&nbsp;{{ global.organization.ChamberOfCommerceAddress.Name }}
    </p>
    <p class="mb-4" style="font-size: 0.75rem">
      <a href="{{ global.organization.Address.Website }}" target="_blank" style="color: #344767">
        {{ global.organization.Address.Website }}
      </a>
    </p>
    -->
  </div>
</div>
